<asax-result-table-search-table-cell-popover [text]="projectCode">
  <title *ngTemplateOutlet="projectTitle"></title>
  <content *ngTemplateOutlet="projectContent"></content>
</asax-result-table-search-table-cell-popover>

<ng-template #projectTitle>
  <i class="fa-light fa-lightbulb me-1"></i>Project {{projectCode}}
</ng-template>

<ng-template #projectContent>
  <ng-container *ngIf="!isLoading; else loading">
    <ul class="list list-unstyled d-flex flex-column gap-2"
        style="overflow-y: auto;max-height: 50vh; max-width: 40vw;">
      <li><strong>Project title</strong>: {{project?.title}}</li>
      <li><strong>PI name</strong>: {{project?.piName}}</li>
      <li><strong>Proposal abstract</strong>: <span [innerHTML]="project?.proposalAbstract | highlight:  (headerProjectAbstractSearchInputText | async)"></span></li>
      <li><strong>Acknowledgement</strong>: <span innerHTML="This paper makes use of the following ALMA data: ADS/JAO.ALMA#{{projectCode}} ALMA is a partnership of ESO (representing its member states), NSF (USA) and NINS (Japan), together with NRC (Canada), MOST and ASIAA (Taiwan), and KASI (Republic of Korea), in cooperation with the Republic of Chile. The Joint ALMA Observatory is operated by ESO, AUI/NRAO and NAOJ.\nIn addition, publications from NA authors must include the standard NRAO acknowledgement: The National Radio Astronomy Observatory is a facility of the National Science Foundation operated under cooperative agreement by Associated Universities, Inc."></span>
      </li>
    </ul>
  </ng-container>
</ng-template>

<ng-template #loading>
  <div class="d-flex justify-content-center">
    <div class="spinner-border spinner-border-sm" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</ng-template>
